import { FONT_SIZE_VALUES } from 'common/constant';

export default (type, size) => {
    return FONT_SIZE_VALUES[type][size];
};
